import React from 'react'
const HorseNumber = ({ number, colorUrl, showNumber=true }) => {
  return <div className="columns is-mobile">
  { showNumber ? <div className="column is-one-fifth has-text-weight-bold horse-number">
        <div className="number-badge">{number}</div>
    </div> : null }
      <div className="column" style={{padding:"10px 0"}}>
       <img className="silkImage" src={colorUrl} alt="silks" />
      </div>
    <style jsx>{`
      .horse-number {
        padding-top: 5px;
        z-index:99;
      }
      .silkImage {
        width:70px;
        min-width:40px;
      }
    `}</style>
  </div>
}

export default HorseNumber
